var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ipad h-100 p-3 bg-black rounded-10"},[_c('div',{staticClass:"ipad-body bg-white h-100 text-body position-relative"},[_c('demo-scorecard')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }